import React, { useState } from 'react';
import { Accordion, Col } from 'react-bootstrap';
import { Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { Btn, H5 } from '../../../AbstractElements';
import { Accordioncode, Accordionspan, AccordionWithIconOnTitle, Add, CollapsibleGroupItem, ColorPara } from '../../../Constant';

const WithIcon = () => {
  const [isOpen, setIsOpen] = useState(1);
  const toggle = (id) => (isOpen === id ? setIsOpen(null) : setIsOpen(id));
  const data = [
    {
      id: 1,
      icon: 'fa fa-solid fa-briefcase',
    },
    {
      id: 2,
      icon: 'fa fa-solid fa-phone',
    },
    {
      id: 3,
      icon: 'fa fa-solid fa-tasks',
    },
  ];
  return (
    <Col sm='12' xl='6'>
      <Accordion defaultActiveKey='0'>
        <Card>
          <CardHeader className='pb-0'>
            <H5>{AccordionWithIconOnTitle}</H5>
            <span>
              {Add} <code>{Accordioncode}</code> {Accordionspan}
            </span>
          </CardHeader>
          <CardBody>
            <div className='default-according' id='accordion1'>
              {data.map((accordian, i) => (
                <Card key={i}>
                  <CardHeader className='bg-primary'>
                    <H5 className='mb-0'>
                      <Btn as={Card.Header} className='btn btn-link ps-0 text-white' color='default' onClick={() => toggle(accordian.id)}>
                        <i className={`icofont ${accordian.icon}`}></i>
                        {CollapsibleGroupItem}
                        <span className='digits'>{accordian.id}</span>
                      </Btn>
                    </H5>
                  </CardHeader>
                  <Collapse isOpen={isOpen === accordian.id}>
                    <CardBody>{ColorPara}</CardBody>
                  </Collapse>
                </Card>
              ))}
            </div>
          </CardBody>
        </Card>
      </Accordion>
    </Col>
  );
};

export default WithIcon;
